import {
    FETCH_PATIENT_REVIEW_REQUEST,
    FETCH_PATIENT_REVIEW_SUCCESS,
    FETCH_PATIENT_REVIEW_FAILURE,
  } from "../types/PatientReviewTypes";
  
  const initialState = {
    loading: false,
    reviewList: [],
    error: null,
  };
  
  const PatientReviewReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PATIENT_REVIEW_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_PATIENT_REVIEW_SUCCESS:
        return {
          ...state,
          loading: false,
          reviewList: action.payload,
        };
  
      case FETCH_PATIENT_REVIEW_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default PatientReviewReducer;